import { neutral, purple } from '../common/colors';

const _circle = {
  radius: 15,
  color: purple['500'],
};

const _plus = {
  width: 2,
  color: neutral['000'],
};

const _container = {
  width: _circle.radius * 2,
  height: _circle.radius * 2,
};

export const styles = {
  _circle,
  _plus,
  _container,
};
